import { LayoutElement } from "@entaconsulting/form";
import monaco from "monaco-editor";

const getObjectAtCursor = (
  model: monaco.editor.ITextModel,
  position: monaco.Position
): LayoutElement | null => {
  const text = model.getValue();
  const cursorOffset = model.getOffsetAt(position);

  let start = cursorOffset;
  let end = cursorOffset;

  while (start > 0 && text[start] !== "{") {
    start--;
  }

  while (end < text.length && text[end] !== "}") {
    end++;
  }

  if (start >= 0 && end < text.length && start < end) {
    const objectString = text.substring(start, end + 1);
    try {
      const parsedObject = JSON.parse(objectString);
      return parsedObject;
    } catch (error) {
      console.error("Error parsing object:", error);
      return null;
    }
  }

  return null;
};

export default getObjectAtCursor;
